import { render, staticRenderFns } from "./ListWalletView.vue?vue&type=template&id=7f617ce4"
import script from "./ListWalletView.vue?vue&type=script&lang=ts"
export * from "./ListWalletView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports